import { Injectable } from '@angular/core';
import { filter, first } from 'rxjs/operators';
import { SessionQuery } from '../../core/state/session/session.query';

@Injectable({
    providedIn: 'root'
})
export class SbStorageService {
    public static userName: string;
    constructor(private session: SessionQuery) {
        this.session.userName$
            .pipe(
                filter((name) => !!name),
                first()
            )
            .subscribe((name) => {
                SbStorageService.userName = name;
            });
    }

    public localSet(componentName: string, variableName: string, value: any) {
        const storageKey = this.getStorageKey(componentName, variableName);
        localStorage.setItem(storageKey, JSON.stringify(value));
    }

    public localGet(componentName: string, variableName: string) {
        const storageKey = this.getStorageKey(componentName, variableName);
        return JSON.parse(localStorage.getItem(storageKey));
    }

    public sessionSet(componentName: string, variableName: string, value: any) {
        const storageKey = this.getStorageKey(componentName, variableName);
        sessionStorage.setItem(storageKey, JSON.stringify(value));
    }

    public sessionGet(componentName: string, variableName: string) {
        const storageKey = this.getStorageKey(componentName, variableName);
        return JSON.parse(sessionStorage.getItem(storageKey));
    }
    // used if we want to restore the application state to default.
    public clear() {
        localStorage.clear();
        sessionStorage.clear();
    }

    public localRemove(componentName: string, variableName: string) {
        const storageKey = this.getStorageKey(componentName, variableName);
        localStorage.removeItem(storageKey);
    }

    public sessionRemove(componentName: string, variableName: string) {
        const storageKey = this.getStorageKey(componentName, variableName);
        sessionStorage.removeItem(storageKey);
    }

    getStorageKey(componentName: string, variableName: string): string {
        return `${SbStorageService.userName}:${componentName}:${variableName}`;
    }
}
